import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { useMenu } from 'hooks';
import { properCase } from 'lib/utils';

const AchievementItem = ({
	achievement,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(achievement, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(achievement, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(achievement.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(achievement)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(achievement)}
						name="achievement"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">
					{achievement?.user?.first_name} {achievement?.user?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{achievement?.reward?.title}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{achievement.points_achieved}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{properCase(achievement.status)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{achievement.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default AchievementItem;
